module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vanguard-payment-method-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethodLocale),
      expression: "paymentMethodLocale"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "id": "vanguard-payment-method-switch-sepa"
    },
    domProps: {
      "value": _vm.constants.PAYMENT_METHOD_SEPA,
      "checked": _vm._q(_vm.paymentMethodLocale, _vm.constants.PAYMENT_METHOD_SEPA)
    },
    on: {
      "change": function($event) {
        _vm.paymentMethodLocale = _vm.constants.PAYMENT_METHOD_SEPA
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentMethodLocale),
      expression: "paymentMethodLocale"
    }],
    attrs: {
      "type": "radio",
      "name": "payment",
      "id": "vanguard-payment-method-switch-bank-card"
    },
    domProps: {
      "value": _vm.constants.PAYMENT_METHOD_BANK_CARD,
      "checked": _vm._q(_vm.paymentMethodLocale, _vm.constants.PAYMENT_METHOD_BANK_CARD)
    },
    on: {
      "change": function($event) {
        _vm.paymentMethodLocale = _vm.constants.PAYMENT_METHOD_BANK_CARD
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "vanguard-payment-method-switch-sepa",
    attrs: {
      "for": "vanguard-payment-method-switch-sepa"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "vanguard-payment-method-switch-bank-card",
    attrs: {
      "for": "vanguard-payment-method-switch-bank-card"
    }
  }, [_vm._v(_vm._s(_vm.Utils.capitalizeFirstLetter(_vm.$t("all.bank_card"))))]), _vm._v(" "), _c('div', {
    staticClass: "vanguard-payment-method-switch-indicator"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97c3e6be","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/payment-switch-button.vue
// module id = 854
// module chunks = 0 1